export default __webpack_public_path__ + "static/lightning_benefits-cfe06159a44d0c6d06089fef82cbfa97.png";